import Template from "backbone/projects/templates/pagination_button.js.hamlc"

export default class PaginationButtonView extends Backbone.View
  events:
    "click .js-load-more" : "loadMore"

  initialize: ->
    @collection = @options.collection
    @hasNextPage = @options.hasNextPage
    @listenTo(@collection, "render", @render)
    @listenTo(@collection, "change:editMode", @render)

  render: (options) ->
    @hasNextPage = options.hasNextPage if options && options.hasNextPage != undefined
    @$el.html(Template(collection: @collection, hasNextPage: @hasNextPage))

  loadMore: ->
    @collection.fetchMore() unless @collection.editingProject()



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/pagination_button_view.js.coffee